export const DATE_STATE = {
    THIS: 'This',
    LAST: 'Last',
    NEXT: 'Next',
};
